import * as React from 'react';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';

const InputWithButton = React.forwardRef(({onSubmit}, inputRef) => {
    return (
        <Paper
          component="form"
          sx={{ 
            p: '2px 4px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            width: 400 }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="New List name"
            inputProps={{ 'aria-label': 'new list name' }}
            inputRef={inputRef}
          />
          <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
          <IconButton color="primary" sx={{ p: '10px' }} aria-label="directions" 
            onClick={onSubmit}>
            <DoubleArrowIcon />
          </IconButton>
        </Paper>
      );
});

export default InputWithButton;